(function blixFaqInit() {
    const blixQuestions = document.querySelectorAll("#blix-faq-wrapper .blix-faq-question");

    blixQuestions.forEach((btn) => {
      btn.addEventListener("click", () => {
        const item = btn.closest(".blix-faq-item");
        const isActive = item.classList.contains("blix-active");

        document.querySelectorAll("#blix-faq-wrapper .blix-faq-item").forEach((i) => {
          i.classList.remove("blix-active");
          i.querySelector(".blix-faq-icon").textContent = "+";
        });

        if (!isActive) {
          item.classList.add("blix-active");
          btn.querySelector(".blix-faq-icon").textContent = "−";
        }
      });
    });
  })();